import React, { FC } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import Spinner from "../atoms/Spinner";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
const Core: FC = () => {
  const accessCheckLoading = useAccessCheckLoading()
  return (
    <>
      <MainLayout>
      <AccessControl
        requiredPermissions={[
          {
            permission: "Knowledge_core",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
      
        <SectionHeader back ={true} title="The core"></SectionHeader>

        <WindowHeightComponent className={""}>
          <div className="row m-0">
            <div className="col-6">
              <div className="ps-3 py-3">

                
                     <AccessControl
                        requiredPermissions={[
                          {
                            permission:'Knowledge_0rganisation',
                            types: ["read"],
                          },
                        ]}
                        renderNoAccess={<></>}
                      >
                <hr />
               
                </AccessControl>
                <div className=" mb-2">
                  <Link className="core_title" to={"/partner-tab"}>Create partner company</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <Link className="core_title" to={"/create-company"}>Create company</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <Link className="core_title" to={"/add_space"}>Create knowledge hub</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <Link className="core_title" to={"/add_crew"}>Create crew</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <a href="#" className="core_title">Create prompting</a>
                </div>
                <hr />
              </div>
            </div>
            <div className="col-6">
              <div className="px-2 py-3">
              <div className=" mb-2">
                  <Link className="core_title" to={"/manage-companies"}>Manage companies</Link>
                </div>
                <hr/>
              <div className=" mb-2">
                  <Link className="core_title" to={"/manage-partner-company"}>Manage partner company</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <Link className="core_title" to={"/knowledge-hubs"}>Manage knowledge hubs</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <Link className="core_title" to={"/crews"}>Manage crews</Link>
                </div>
                <hr />
                <div className=" mb-2">
                  <a href="#" className="core_title">Manage promptings</a>
                </div>
                <hr />
                <div className="mb-2">
                  <a href="/manage-users" className="core_title">Manage users</a>
                </div>
                <hr />
                <div className="">
                  <Link to={"/configuration"} className="core_title">Configurations</Link>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </WindowHeightComponent>
</AccessControl>
      </MainLayout>
    </>
  );
};
export default Core;
